import { useEffect, useState } from 'react'
import { useStripe, useElements } from '@stripe/react-stripe-js'
import styled from 'astroturf/react'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'

import { useI18n } from 'locales'

import Badge from '../payment/stripe/badge'
import { PaymentElementField } from '../payment/stripe/payment_element_field'
import _FormContainer from "InvoiceStripeForm-FormContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/invoice/InvoiceStripeForm.js?styleId=FormContainer";
import _StripeNoteText from "InvoiceStripeForm-StripeNoteText.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/invoice/InvoiceStripeForm.js?styleId=StripeNoteText";
import _MediumSpacingDiv from "InvoiceStripeForm-MediumSpacingDiv.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/invoice/InvoiceStripeForm.js?styleId=MediumSpacingDiv";


const FormContainer = /*#__PURE__*/styled("div", null, {
  displayName: "FormContainer",
  styles: _FormContainer
})

const StripeNoteText = /*#__PURE__*/styled("small", null, {
  displayName: "StripeNoteText",
  styles: _StripeNoteText
})

const MediumSpacingDiv = /*#__PURE__*/styled("div", null, {
  displayName: "MediumSpacingDiv",
  styles: _MediumSpacingDiv
})

export const InvoiceStripeForm = ({ registerApi, clientSecret }) => {
  const stripe = useStripe()
  const elements = useElements()
  const [error, setError] = useState(null)
  const { i18n } = useI18n()

  useEffect(() => {
    if (!stripe || !elements) return

    const createPayment = async () => {
      setError(null)

      const { error: validationError } = await elements.submit()
      if (validationError) {
        setError(validationError.message)
        return false
      }

      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: window.location.href,
        },
        redirect: 'if_required',
      })

      if (result.error) {
        setError(result.error.message)
        return false
      }

      if (result.paymentIntent?.last_payment_error) {
        setError(
          result.paymentIntent.last_payment_error.message ||
            i18n.t('errors.billing.card.payment_failed'),
        )
        return false
      }

      if (result.paymentIntent?.status === 'requires_capture') {
        return true
      }

      return false
    }

    const getPaymentData = () => ({
      payment_intent_client_secret: clientSecret,
    })

    registerApi({ createPayment, getPaymentData })
  }, [stripe, elements, registerApi, clientSecret, i18n])

  return (
    <FormContainer>
      <MediumSpacingDiv>
        <PaymentElementField error={error} onChange={() => {}} />
      </MediumSpacingDiv>
      <StripeNoteText>
        {i18n.t('booking.templates.payment.stripe_note')}
      </StripeNoteText>
      <Badge />
    </FormContainer>
  )
}
